/*
  Prepend an "All" entry to the specified array of options
*/
export default function prependAllOption(options: Array<object>) {
  return [{ id: null, name: 'All' }, ...options]
}
